"use client"

import { Routes, Route } from "react-router-dom"
import { useEffect } from "react"
import Header from "./components/Header"
import HomePage from "./pages/HomePage"
import AdminPage from "./pages/AdminPage"
import AdminLogin from "./pages/AdminLogin"
import AdminSignup from "./pages/AdminSignup"
import AboutPage from "./pages/AboutPage"
import CropRotationPage from "./pages/CropRotationPage"
import WeatherInformationPage from "./pages/WeatherInformationPage"
import PWAInstallPrompt from "./components/PWAInstallPrompt"
import { AuthProvider } from "./contexts/AuthContext"
import ProtectedRoute from "./components/ProtectedRoute"
import { registerServiceWorker } from "./utils/pwaUtils"

function App() {
  useEffect(() => {
    // Register service worker for PWA functionality
    registerServiceWorker()
  }, [])

  return (
    <AuthProvider>
      <div className="App">
        <Header />
        <main>
          <PWAInstallPrompt />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/crop-rotation" element={<CropRotationPage />} />
            <Route path="/weather" element={<WeatherInformationPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/signup" element={<AdminSignup />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
      </div>
    </AuthProvider>
  )
}

export default App
